<pagination-template
  #p="paginationApi"
  [id]="id"
  [maxSize]="maxSize"
  (pageChange)="pageChange.emit($event)"
  (pageBoundsCorrection)="pageBoundsCorrection.emit($event)"
>
  <nav role="navigation" [attr.aria-label]="screenReaderPaginationLabel">
    <ul
      class="ngx-pagination"
      [class.responsive]="responsive"
      *ngIf="!(autoHide && p.pages.length <= 1)"
    >
      <li
        class="pagination-previous"
        [class.disabled]="p.isFirstPage()"
        *ngIf="directionLinks"
      >
        <a
          tabindex="0"
          *ngIf="1 < p.getCurrent()"
          [routerLink]="[]"
          [queryParams]="{ page: p.getCurrent() - 1 }"
          queryParamsHandling="merge"
          (keyup.enter)="p.previous()"
          (click)="p.previous()"
        >
          {{ previousLabel }}
          <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </a>
        <span *ngIf="p.isFirstPage()" aria-disabled="true">
          {{ previousLabel }}
          <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </span>
      </li>
      <li class="small-screen">{{ p.getCurrent() }} / {{ p.getLastPage() }}</li>
      <li
        [class.current]="p.getCurrent() === page.value"
        [class.ellipsis]="page.label === '...'"
        *ngFor="let page of p.pages; trackBy: trackByIndex"
      >
        <a
          tabindex="0"
          [routerLink]="[]"
          [queryParams]="{ page: page.value }"
          queryParamsHandling="merge"
          (keyup.enter)="p.setCurrent(page.value)"
          (click)="p.setCurrent(page.value)"
          *ngIf="p.getCurrent() !== page.value"
        >
          <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
          <span>{{
            page.label === '...' ? page.label : (page.label | number: '')
          }}</span>
        </a>
        <ng-container *ngIf="p.getCurrent() === page.value">
          <span aria-live="polite">
            <span class="show-for-sr">{{ screenReaderCurrentLabel }} </span>
            <span>{{
              page.label === '...' ? page.label : (page.label | number: '')
            }}</span>
          </span>
        </ng-container>
      </li>
      <li
        class="pagination-next"
        [class.disabled]="p.isLastPage()"
        *ngIf="directionLinks"
      >
        <a
          tabindex="0"
          *ngIf="!p.isLastPage()"
          [routerLink]="[]"
          [queryParams]="{ page: p.getCurrent() + 1 }"
          queryParamsHandling="merge"
          (keyup.enter)="p.next()"
          (click)="p.next()"
        >
          {{ nextLabel }}
          <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </a>
        <span *ngIf="p.isLastPage()" aria-disabled="true">
          {{ nextLabel }}
          <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </span>
      </li>
    </ul>
  </nav>
</pagination-template>
